const FAVMESSAGE = "Emisión solicitada";
const STATICCOLORS = `\
:root {\
  --primary-color:#4800d1;\
  --company-color: #084c8b;\
  --header-color: #084c8b;\
  --table-color: #686868;\
  --offer-color: #686868;\
  --title-color: #084c8b;\
  --gray-color: #585858;\
  --fav-color: rgba(0,128,0);\
  --fav-mess-color: rgba(0,128,0);\
  --price-color: rgba(32, 132, 227, 1);\
}\
`;
const WAITPOLICIESTIME = {
  vehiculos: 50000,
  vida: 50000,
  hogar: 120000,
  default: 50000,
}; // miliseconds
const ALLIANCEMESSAGEKEY = "Responsable legal";

export { FAVMESSAGE, STATICCOLORS, WAITPOLICIESTIME, ALLIANCEMESSAGEKEY };
